import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col, Button, Table } from 'react-bootstrap'
import ThemeTable from '../component/ThemeTable'
import PurchaseService from '../services/Purchase'
import Loader from '../component/Loader'
import { useNavigate } from 'react-router-dom'
import DatePicker from '../component/DatePicker'
import InputField from '../component/InputField'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import Form from "react-bootstrap/Form";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import toast from 'react-hot-toast'
import RegistrationService from '../services/registration'
import SelectDropDown from '../component/SelectDropDown'
import NoData from '../component/NoData'
const MyContractor = () => {
  const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");
  
  const isHierDesc = userInfo?.description || null;
  const [loading, setLoading] = useState(true);
  const [searchMobile, setSearchMobile] = useState("")
  const [searchCustomerName, setSearchCustomerName] = useState("")
  const [forSearch, setForSearch] = useState({
    mobile: "",
    customer: "",
    dealer: ""
  })
  const [purchaseList, setIsPurchaseList] = useState([])
  const [isDataFound, setIsDataFound] = useState(false)
  const [conversionFactor, setConversionFactor] = useState(0.5)
  const [tseSectionBlock, setTseSectionBlock] = useState(false)
  const [isSearchMobile, setIsSearchMobile] = useState('')
  const [isSearchName, setIsSearchName] = useState('')
  const [isSearchSingleData, setIsSearchSingleData] = useState(false)
  const [searchDealer, setSearchDealer] = useState({id: "", title: ""})
  const [isActionBTNClicked, setIsActionBTNClicked] = useState(false);
  const [isTableDataFound, setIsTableDataFound] = useState(false);
  const [allDealers, setAllDealers] = useState([])
  const [showMore, setShowMore] = useState(true);
  const [pageNo, setPageNo] = useState(1);
    // Load state from localStorage on component mount
    useEffect(() => {
      RegistrationService.myDealersTSE(userInfo.dcm_contacts_id).then(res => {

        let dealerlist = res.response.dealerList.map(product => {
          return {
            id: product.contact_id,
            title: product.name + ' (' + product.id_extern01 + ')',
          };
        });

        let arslist = res.response.arsList.map(product => {
          return {
            id: product.contact_id,
            title: product.name + ' (' + product.id_extern01 + ')',
          };
        });

        let retailerlist = res.response.retailerList.map(product => {
          return {
            id: product.contact_id,
            title: product.name + ' (' + product.id_extern01 + ')',
          };
        });

        setAllDealers(dealerlist.concat(arslist, retailerlist));
      });
      const savedSearchMobile = localStorage.getItem('isSearchMobile');
      const savedSearchName = localStorage.getItem('isSearchName');
  
      if (savedSearchMobile) setIsSearchMobile(savedSearchMobile);
      if (savedSearchName) setIsSearchName(savedSearchName);
      if (searchDealer) setSearchDealer(searchDealer);
    }, []);
  
    //Save state to localStorage whenever it changes
    // useEffect(() => {
    //   localStorage.setItem('isSearchMobile', isSearchMobile);
    //   localStorage.setItem('isSearchName', isSearchName);
    //   localStorage.setItem('isSearchPurchaseDate', isSearchPurchaseDate);
    // }, [isSearchMobile, isSearchName, searchDealer]);
  //Conversion
  const ConversionFactorData = async () => {
    const token = localStorage.getItem('access_token')
    try {
      const ConversionDataResponse = await PurchaseService.conversionFactor(token)
      if (ConversionDataResponse.success == true) {
        setConversionFactor(parseFloat(ConversionDataResponse.response.conversionDetails));
      }
      if (!isNaN(conversionFactor)) {
        setConversionFactor(conversionFactor);
      }
    }
    catch (e) {
    }
  }

  //Purchase List
  const fetchMyContractor = async () => {
    try {
      // const contactId = userInfo.dcm_contacts_id;
      // if (isHierDesc == "TSE") {
        
      //   setTseSectionBlock(true)
      //   setLoading(false)
       
      // }
      // else {
      //   setTseSectionBlock(false)
      //   setLoading(false)
      // }
      const token = localStorage.getItem('access_token')
      
      const MyContractors = await RegistrationService.myContractorsTSE(forSearch.customer, forSearch.mobile, forSearch.dealer, (pageNo-1)*10, token)
      if (MyContractors.success == true && MyContractors.response.status == "true" && MyContractors.response.userDetails.length > 0) {
       const filteredData = MyContractors.response.userDetails.map((item, index) => {
          const id = item.contact_id
          const name = item?.full_name
          const mobile = item.phone_number
          const id_extern = item.id_extern01
          const parentDealer = item.dealer_name
          const status = item.business_active
          const pan = item.pan ? item.pan : "<<--Not Available-->>";
          const tier = item?.current_tier?.tierName
          
          return {
            'id' : id,
            'Name': name,
            'Mobile no.': mobile,
            'External Id': id_extern,
            'Parent dealer': parentDealer,
            'Status': status,
            'PAN': pan,
            'Tier': tier,
          };
        });
        setIsTableDataFound(true)
        // setIsDataFound(false);
        setLoading(false);
        setIsSearchSingleData(false);
        const id_extern01 = [];
        const filteredDataUni = filteredData.filter(item => {
          if (id_extern01.includes(item['External Id'])) {
            return false;
          } else {
            id_extern01.push(item['External Id']);
            return true;
          }
        });

        return filteredDataUni;
        
      } 
      else if (MyContractors.success == true && MyContractors.response.status == "true" && MyContractors.response.userDetails.length == 0)
      {
        setIsTableDataFound(false)
        setIsSearchSingleData(true)
        setLoading(false);
      }
      
      else  {
        setIsTableDataFound(false)
        setIsSearchSingleData(true)
        setLoading(false);
      }
      return []
    }

    
    catch (e) {
      console.error("Error fetching contractors");
    }
  }

  useEffect(() => {
    ConversionFactorData();
   }, [])
  useEffect(() => {

    // if (isHierDesc !== null) {
      
   if(pageNo > 1) {
    async function fetchData() {
      const data = await fetchMyContractor();
      if(data.length == 0) {
        setShowMore(false);
        toast.error("No more contractors");
      }
      setIsPurchaseList( p => [...p, ...data]);
    }
    fetchData()
   }   
    // }
  }, [pageNo])
  useEffect(() => {
    setPageNo(1);
    async function callApi(){
      const data = await fetchMyContractor();
      setIsPurchaseList(data);
    }
    callApi()
    
  }, [forSearch])
  const navigate = useNavigate()

  const handleSearchMobile = (e) => {
    setSearchMobile(e.target.value.replace(/\D/g, ''))
   
  }

 
  const handleSearchName = (e) => {
    setSearchCustomerName(e.target.value)
  }

  const handleSearch = () => {
    setShowMore(true);
    setPageNo(1);
    setTimeout(() => {
      setForSearch({mobile: searchMobile, customer: searchCustomerName, dealer: searchDealer.id})
    },800)
    // fetchMyContractor();
  }
  const handleClear =()=>{
    // setIsActionBTNClicked(!isActionBTNClicked)
    // setIsSearchMobile('');
    // setIsSearchName('');
    // setIsSearchPurchaseDate('');
    // fetchMyContractor();
    // localStorage.removeItem('isSearchMobile');
    // localStorage.removeItem('isSearchName');
    // localStorage.removeItem('isSearchPurchaseDate');
    setForSearch({mobile: "", customer: "", dealer: ""});
    setSearchMobile("")
    setSearchCustomerName("")
    setSearchDealer({id: "", title: ""})
    setPageNo(1)
    setShowMore(true);
    
  }

  function onRowClick(item) {
    
    navigate(`/my-contractor/${item.id}`)
  }

  function tierColor(tier) {
    return 'bronze-tier'
  }

  return (
    <>
      {/* {loading && <Loader />} */}

      <BreadCrumbSecttion pageTitle="My Contractor" currentPageName="My Contractor" />
      <section className='padTop50'>
      {/* {allMarked.length > 0 && <Button className='float-footer' onClick={approveAll}>Approve All</Button>} */}
        <Container>
          <Row>         
            {
              !isDataFound &&
              (
                <>
                  {/* {tseSectionBlock && */}
                    <Col xs={12} lg={12}>
                      <div className='searchBoxBlock my-4'>
                        <Row>
                          <Col xs={12} lg={3}>
                            <InputField inputFieldLabel="Search By Mobile"
                              onChange={handleSearchMobile}
                              value={searchMobile} />
                          </Col>
                          <Col xs={12} lg={3}>
                            <InputField inputFieldLabel="Search By Customer Name"
                              value={searchCustomerName}
                              onChange={handleSearchName} />
                          </Col>
                          <Col xs={12} lg={3}>
                          <SelectDropDown
                            labelName="Search By Dealer / ARS / Retailer"
                            // requiredStar="*"
                            options={allDealers}
                            // onChange={handleKYCChange}
                            selectedValue={searchDealer}
                            setSelectedValue={setSearchDealer}
                            name="selectDealer"
                            page="searchFilter"
                          />
                          </Col>
                          <Col xs={12} lg={3} className='mt-4'>
                            <Row>
                            <Col xs={12} lg ={6}>
                               <PrimaryGradientButton buttonText="Search" onClick={handleSearch} />
                              </Col>
                              <Col xs={12} lg ={6}>
                                 <PrimaryOutLineButton outlinebuttonText="Clear" onClick={handleClear}/>
                              </Col>
                              
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                   
                  {purchaseList.length == 0 && !loading &&
                    <Col xs={12}>
                      <NoData />
                    </Col>}
                    {loading && 
                    <Col xs={12}>
                      <NoData title="fetching.." />
                    </Col>}
                  {/* {isTableDataFound &&   */}
                  <Col xs={12} lg={12} className='purchaseListTable'>
                   {purchaseList.length > 0 && <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                            {Object.keys(purchaseList[0]).map((header, index) => {
                              if(header == "id") return <th key={index}>SNo.</th>
                              return (
                                    <th key={index}>{header}</th>
                                )
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {purchaseList.map((item, indexId) => {
                            const keysArray = Object.keys(item);
                                return (
                                    <tr key={indexId} onClick={() => onRowClick(item)} className={"cursor-pointer"}>
                                        {keysArray.map((key, index) => {
                                            if(key == "id") return  <td key={index}><div className="text-center">{indexId+1}</div></td>
                                            return (
                                                <td key={index}>{ 
                                                // <div className={"text-center"+` ${item[key]?.toLowerCase()} ${key==="Tier" ? 'text-white text-bold' : ''}`}>{item[key]}</div>
                                                <div
                                                  className={
                                                   "text-center " +
                                                    (key === "Tier"
                                                    ? `${tierColor(item[key])} text-white text-bold`
                                                    : item[key]?.toLowerCase())
                                                  }
                                                  >
                                                    {item[key]}
                                                  </div>

                                                }</td>
                                            )
                                        })}

                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>}
                  </Col>
                   {/* } */}
                </>
              )
            }

          </Row>
         {purchaseList.length > 0 && <Row className='justify-content-center'>
            <Col xs={12} lg={3}>
                <PrimaryGradientButton disabled={!showMore} onClick={() => setPageNo(p => p+1 )} buttonText='Show More' />
            </Col>
          </Row>}

        </Container>
      </section>
      <style>
      {`
        .bronze-tier {
        background-color: #cd7f32; /* Bronze shade */
        padding: 4px 8px;
        border-radius: 4px;
        display: inline-block;
        min-width: 100px;
        }
      `}
    </style>
    </>
  )
}

export default MyContractor
